import React, { useContext, useState } from "react";
import { ViewContext } from "./contexts/ViewContext";
//import { makeStyles } from "@mui/styles";
import PoiList from "./PoiList";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AccessibleForwardIcon from "@mui/icons-material/AccessibleForward";
import WcIcon from "@mui/icons-material/Wc";
import { Grid, TextField } from "@mui/material";
import { savePoiAccessibility } from "./utils/savePoiAccessibility";
import "./PoiEdit.css";

const COLORS = [
    { value: "yes", color: "#36d3c1" },
    { value: "limited", color: "#ffa55c" },
    { value: "no", color: "#ff477b" },
    { value: "", color: "#bdbdbd" },
];

export default function PoiEdit() {
    const { view, dispatch } = useContext(ViewContext);
    const { poi, originalPoi } = view;
    const [wheelchairData, setWheelchairData] = useState({
        wheelchair: poi.tags.wheelchair || "",
        "toilets:wheelchair": poi.tags["toilets:wheelchair"] || "",
        "wheelchair:description": poi.tags["wheelchair:description"] || "",
    });
    console.log(wheelchairData);

    const handleChange = (tag, value) => {
        let tempPoi = { ...poi };
        if (value) {
            tempPoi.tags[tag] = value;
        } else {
            delete tempPoi.tags[tag];
        }
        dispatch({ type: "EDIT POI", poi: tempPoi });

        setWheelchairData({ ...wheelchairData, [tag]: value });
    };

    const entranceRating = COLORS.map((e) => {
        let selected = wheelchairData.wheelchair === e.value;
        let color = e.color;
        return (
            <IconButton
                aria-label={e.value}
                key={e.value}
                style={{
                    color: selected ? "white" : color,
                    backgroundColor: selected ? color : "white",
                    border: `1px solid ${color}`,
                    margin: 8,
                    "--hover-color": color,
                }}
                onClick={() => handleChange("wheelchair", e.value)}
            >
                <AccessibleForwardIcon />
            </IconButton>
        );
    });

    const toiletsRating = COLORS.map((e) => {
        let selected = wheelchairData["toilets:wheelchair"] === e.value;
        let color = e.color;
        return (
            <IconButton
                aria-label={e.value}
                key={e.value}
                style={{
                    color: selected ? "white" : color,
                    backgroundColor: selected ? color : "white",
                    border: `1px solid ${color}`,
                    margin: 8,
                    "--hover-color": color,
                }}
                onClick={() => handleChange("toilets:wheelchair", e.value)}
            >
                <WcIcon />
            </IconButton>
        );
    });
    const accessibilityHasChanged = () => {
        if (
            poi.tags.wheelchair === originalPoi.tags.wheelchair &&
            poi.tags["toilets:wheelchair"] ===
                originalPoi.tags["toilets:wheelchair"] &&
            poi.tags["wheelchair:description"] ===
                originalPoi.tags["wheelchair:description"]
        ) {
            return false;
        } else return true;
    };

    const handleSave = () => {
        console.log(poi);

        (async () => {
            const response = await savePoiAccessibility(poi);
            console.log(response);
            dispatch({ type: "CHANGE PAGE", pageType: "poi", direction: 1 });
        })();
    };
    return (
        <>
            <PoiList pois={[poi]} />
            {view.locale === "hu"
                ? "Bejárat akadálymentessége:"
                : view.locale === "en" && "Entrance accessibility"}
            <div className="{classes.root}">{entranceRating}</div>
            {view.locale === "hu"
                ? "Mellékhelyiség akadálymentessége:"
                : view.locale === "en" && "Toilets accessibility"}
            <div className="{classes.root}">{toiletsRating}</div>
            <TextField
                id="outlined-basic"
                label={
                    view.locale === "hu"
                        ? "Akadálymentesség megjegyzés"
                        : view.locale === "en" && "Accessibility description"
                }
                variant="outlined"
                value={wheelchairData["wheelchair:description"]}
                onChange={(evt) =>
                    handleChange("wheelchair:description", evt.target.value)
                }
                margin="normal"
                fullWidth
            />
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
                style={{ marginBottom: "16px" }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={!accessibilityHasChanged()}
                >
                    {view.locale === "hu"
                        ? "Mentés"
                        : view.locale === "en" && "Save"}
                </Button>
            </Grid>
        </>
    );
}
